import { instance } from "./base.api";

const endpoint = "/providers";

export const providers = {
  getAll: () => {
    return instance.get(endpoint);
  },
  getById: (id: number) => {
    return instance.get(`${endpoint}/${id}`);
  },
  getItemById: (prefixedId: string) => {
    return instance.get(`${endpoint}/item/${prefixedId}`);
  },
  getBalance: (fechaHasta?: string) => {
    const params = fechaHasta ? `?hasta=${fechaHasta}` : '';
    return instance.get(`${endpoint}/balance${params}`);
  },
  create: (providerData: any) => {
    return instance.post(endpoint, providerData);
  },
  update: (id: number, providerData: any) => {
    return instance.put(`${endpoint}/${id}`, providerData);
  },
  delete: (id: number) => {
    return instance.delete(`${endpoint}/${id}`);
  },
};
